import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
//import logo
import BrandLogo from "../Components/Common/BrandLogo";

//Import Components
import VerticalLayout from "./VerticalLayouts";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toggleSidebarMenu } from "../utils/layoutToggle";
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";
import TwoColumnLayout from "./TwoColumnLayout";
import { changeSidebarVisibility } from "../slices/thunks";
const Sidebar = ({ layoutType }) => {

  // MOBILE (Round M1): register the drawer-close listeners ONCE with proper
  // cleanup. Previously this effect ran on every render and attached a fresh
  // (never-removed) click listener to the overlay each time.
  useEffect(() => {
    const closeDrawer = () => document.body.classList.remove("vertical-sidebar-enable");

    const overlay = document.querySelector(".vertical-overlay");
    if (overlay) overlay.addEventListener("click", closeDrawer);

    // Selecting a navigation item closes the drawer on phones.
    const menu = document.querySelector(".app-menu");
    const onMenuClick = (e) => {
      if (document.documentElement.clientWidth > 767) return;
      const link = e.target.closest("a");
      if (!link) return;
      // Keep the drawer open when tapping a group header that only
      // expands/collapses a sub-menu.
      if (link.getAttribute("data-bs-toggle") === "collapse") return;
      closeDrawer();
    };
    if (menu) menu.addEventListener("click", onMenuClick);

    // Escape closes the drawer where a keyboard is available.
    const onKeyDown = (e) => {
      if (e.key === "Escape" && document.body.classList.contains("vertical-sidebar-enable")) {
        closeDrawer();
      }
    };
    document.addEventListener("keydown", onKeyDown);

    return () => {
      if (overlay) overlay.removeEventListener("click", closeDrawer);
      if (menu) menu.removeEventListener("click", onMenuClick);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  const dispatch = useDispatch();

  const { sidebarVisibilitytype } = useSelector(state => ({
    sidebarVisibilitytype: state.Layout.sidebarVisibilitytype
  }), shallowEqual);

  const toggleSidebar = () => {
    var windowSize = document.documentElement.clientWidth;
    dispatch(changeSidebarVisibility("show"));

    // For collapse vertical and semibox menu
    if (
      sidebarVisibilitytype === "show" &&
      (document.documentElement.getAttribute("data-layout") === "vertical" ||
        document.documentElement.getAttribute("data-layout") === "semibox")
    ) {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        (document.documentElement.getAttribute("data-sidebar-size") === "sm-hover")
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        (document.documentElement.getAttribute("data-sidebar-size") === "lg")
          ? document.documentElement.setAttribute("data-sidebar-size", "sm-hover")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        // MOBILE (Round M1): toggle so this button can also close the drawer.
        document.body.classList.toggle("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    // Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };




  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };
  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <button
          type="button"
          className="sidebar-float-toggle"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
          <span className="chev">‹‹</span>
        </button>
        <div className="navbar-brand-box sidebar-header">

          <div className="sidebar-logo">
            <Link to="/" className="logo">
              {/* Single 3D brand logo. The component shows one cycling mark and
                  handles its own sizing; no separate dark/light or sm/lg copies
                  (that produced duplicate spinning logos). */}
              <BrandLogo height={38} />
            </Link>
          </div>



        </div>




        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === 'twocolumn' ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <div
                className="sidebar-content"
                style={{
                  paddingBottom: "50px",
                  paddingTop: "5px",
                  paddingLeft: "2px",
                  paddingRight: "2px",
                }}
              >
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </div>
            </SimpleBar>
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
